import { Injectable } from '@angular/core';
import {
    Permission,
    IUserPermissions,
    FullPermission,
} from '@shared/model/permission.model';
import { LOCAL_STORAGE_KEY, StorageService } from './storage.service';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    private userPermissions: IUserPermissions = {};

    constructor(public storageService: StorageService) {
        this.setUserPermissions(
            JSON.parse(
                this.storageService.getItem(LOCAL_STORAGE_KEY.PERMISSIONS)!
            )
        );
    }

    /**
     * Sets user permissions from the provided permissions object.
     * @param permissions - The permissions object to set.
     */
    setUserPermissions(permissions: IUserPermissions) {
        this.userPermissions = permissions;
    }

    /**
     * Checks if the user has the required permission for a specific module.
     * @param moduleId - The ID of the module to check permissions for.
     * @param requiredRole - The required permission role to check against.
     * @returns True if the user has the required permission, false otherwise.
     */
    hasPermission(moduleId: number, requiredRole: Permission): boolean {
        const roles = this.userPermissions?.[moduleId];

        if (roles) {
            if (roles.includes(FullPermission)) return true;
            return roles.includes(requiredRole);
        } else return false;
    }
}
